(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nilotica-product-main"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  // Thumbnail gallery
  var mainImg = document.getElementById('sou-main-image');
  var mainScroll = document.querySelector('.sou-gallery__main-scroll');
  var mainFrames = document.querySelectorAll('.sou-gallery__main-scroll .sou-gallery__main');
  var thumbs = document.querySelectorAll('.sou-thumb');
  thumbs.forEach(function(thumb, idx){
    thumb.addEventListener('click', function(){
      thumbs.forEach(function(t){t.classList.remove('is-active')});
      thumb.classList.add('is-active');
      if(mainImg){
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt;
      }
      if(mainScroll && mainFrames[idx]){
        mainFrames[idx].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
      }
    });
  });

  // Pack card selection
  var packCards     = document.querySelectorAll('.sou-pack-card');
  var variantInput  = document.getElementById('sou-variant-id');
  var priceCurrentEl= document.getElementById('sou-price-current');
  var priceCompareEl= document.getElementById('sou-price-compare');
  var savingsLineEl = document.getElementById('sou-savings-line');
  var savingsAmtEl  = document.getElementById('sou-savings-amount');
  var atcBtn        = document.getElementById('sou-atc-btn');
  var atcText       = document.getElementById('sou-atc-text');

  function updateSavingsLine(savings) {
    if(savings && savingsLineEl && savingsAmtEl){
      savingsAmtEl.textContent = savings;
      savingsLineEl.classList.remove('sou-hidden');
    } else if(savingsLineEl){
      savingsLineEl.classList.add('sou-hidden');
    }
  }

  packCards.forEach(function(card){
    card.addEventListener('click', function(){
      var radio = card.querySelector('.sou-pack-radio');
      if(radio.disabled) return;

      packCards.forEach(function(c){c.classList.remove('is-selected')});
      card.classList.add('is-selected');
      radio.checked = true;

      variantInput.value = card.dataset.variantId;
      priceCurrentEl.textContent = card.dataset.price;

      if(card.dataset.hasCompare === 'true'){
        priceCompareEl.textContent = card.dataset.compare;
        priceCompareEl.classList.remove('sou-hidden');
      } else {
        priceCompareEl.textContent = '';
        priceCompareEl.classList.add('sou-hidden');
      }

      // Update savings confirmation line
      updateSavingsLine(card.dataset.savings || '');

      atcBtn.disabled = false;
      atcText.textContent = 'Add to Cart';
    });
  });

  // Footer CTA smooth scroll
  var footerBtn = document.getElementById('sou-footer-btn');
  if(footerBtn){
    footerBtn.addEventListener('click', function(e){
      e.preventDefault();
      var target = document.getElementById('sou-pack-selector');
      if(target){ target.scrollIntoView({behavior:'smooth',block:'center'}); }
    });
  }

  // Scroll-triggered section animations
  if('IntersectionObserver' in window){
    var animSections = document.querySelectorAll('.sou-story,.sou-benefits,.sou-lifestyle,.sou-howto,.sou-reviews,.sou-footer-cta');
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('sou-in-view');
          observer.unobserve(entry.target);
        }
      });
    },{threshold:0.08});
    animSections.forEach(function(s){observer.observe(s)});
  } else {
    document.querySelectorAll('.sou-story,.sou-benefits,.sou-lifestyle,.sou-howto,.sou-reviews,.sou-footer-cta')
      .forEach(function(s){s.classList.add('sou-in-view')});
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-testing"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  // Thumbnail gallery
  var mainImg = document.getElementById('sou-main-image');
  var mainScroll = document.querySelector('.sou-gallery__main-scroll');
  var mainFrames = document.querySelectorAll('.sou-gallery__main-scroll .sou-gallery__main');
  var thumbs = document.querySelectorAll('.sou-thumb');
  thumbs.forEach(function(thumb, idx){
    thumb.addEventListener('click', function(){
      thumbs.forEach(function(t){t.classList.remove('is-active')});
      thumb.classList.add('is-active');
      if(mainImg){
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt;
      }
      if(mainScroll && mainFrames[idx]){
        mainFrames[idx].scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
      }
    });
  });

  // Pack card selection
  var packCards     = document.querySelectorAll('.sou-pack-card');
  var variantInput  = document.getElementById('sou-variant-id');
  var priceCurrentEl= document.getElementById('sou-price-current');
  var priceCompareEl= document.getElementById('sou-price-compare');
  var savingsLineEl = document.getElementById('sou-savings-line');
  var savingsAmtEl  = document.getElementById('sou-savings-amount');
  var atcBtn        = document.getElementById('sou-atc-btn');
  var atcText       = document.getElementById('sou-atc-text');

  function updateSavingsLine(savings) {
    if(savings && savingsLineEl && savingsAmtEl){
      savingsAmtEl.textContent = savings;
      savingsLineEl.classList.remove('sou-hidden');
    } else if(savingsLineEl){
      savingsLineEl.classList.add('sou-hidden');
    }
  }

  packCards.forEach(function(card){
    card.addEventListener('click', function(){
      var radio = card.querySelector('.sou-pack-radio');
      if(radio.disabled) return;

      packCards.forEach(function(c){c.classList.remove('is-selected')});
      card.classList.add('is-selected');
      radio.checked = true;

      variantInput.value = card.dataset.variantId;
      priceCurrentEl.textContent = card.dataset.price;

      if(card.dataset.hasCompare === 'true'){
        priceCompareEl.textContent = card.dataset.compare;
        priceCompareEl.classList.remove('sou-hidden');
      } else {
        priceCompareEl.textContent = '';
        priceCompareEl.classList.add('sou-hidden');
      }

      // Update savings confirmation line
      updateSavingsLine(card.dataset.savings || '');

      atcBtn.disabled = false;
      atcText.textContent = 'Add to Cart';
    });
  });

  // Footer CTA smooth scroll
  var footerBtn = document.getElementById('sou-footer-btn');
  if(footerBtn){
    footerBtn.addEventListener('click', function(e){
      e.preventDefault();
      var target = document.getElementById('sou-pack-selector');
      if(target){ target.scrollIntoView({behavior:'smooth',block:'center'}); }
    });
  }

  // Scroll-triggered section animations
  if('IntersectionObserver' in window){
    var animSections = document.querySelectorAll('.sou-story,.sou-benefits,.sou-lifestyle,.sou-howto,.sou-reviews,.sou-footer-cta');
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('sou-in-view');
          observer.unobserve(entry.target);
        }
      });
    },{threshold:0.08});
    animSections.forEach(function(s){observer.observe(s)});
  } else {
    document.querySelectorAll('.sou-story,.sou-benefits,.sou-lifestyle,.sou-howto,.sou-reviews,.sou-footer-cta')
      .forEach(function(s){s.classList.add('sou-in-view')});
  }

})();

  } catch(e) { console.error(e); }
})();
})();
